
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Separator } from "@/components/ui/separator";

const Villkor = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="container mx-auto px-4 pt-32 pb-16 max-w-4xl">
        <h1 className="text-3xl font-bold text-darkgray mb-6 font-montserrat">Användarvillkor</h1>
        
        <div className="prose prose-yellow max-w-none space-y-6 text-darkgray/80 font-opensans">
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">1. Inledning</h2>
            <p>Välkommen till Snabbaupphandlingar. Genom att använda vår webbplats och våra tjänster för upphandlingsanalys godkänner du dessa användarvillkor. Vänligen läs dem noggrant.</p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">2. Definitioner</h2>
            <p>"Tjänsten" avser Snabbaupphandlingar-plattformen och alla relaterade tjänster för analys av upphandlingsunderlag.</p>
            <p>"Användare" avser en person eller organisation som har registrerat sig för att använda Tjänsten.</p>
            <p>"Innehåll" avser all information och material som laddas upp eller tillgängliggörs via Tjänsten, inklusive upphandlingsdokument och analysresultat.</p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">3. Tjänstebeskrivning</h2>
            <p>Snabbaupphandlingar är en AI-driven plattform som hjälper företag att analysera, förstå och optimera sina anbud i offentliga upphandlingar. Tjänsten omfattar funktioner för textanalys, bevakningar, och strategiska rekommendationer.</p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">4. Användarvillkor</h2>
            <p>För att använda Tjänsten måste du:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Representera ett företag eller organisation med organisationsnummer</li>
              <li>Registrera dig med korrekt och fullständig information om ditt företag</li>
              <li>Hålla ditt lösenord säkert och konfidentiellt</li>
              <li>Meddela oss omedelbart om någon obehörig användning av ditt konto eller annan säkerhetsöverträdelse</li>
            </ul>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">5. Användarens skyldigheter</h2>
            <p>Som användare av Tjänsten godkänner du att:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Följa alla tillämpliga lagar och regler för offentlig upphandling</li>
              <li>Inte ladda upp eller dela innehåll som är olagligt, stötande, hotfullt, kränkande eller på annat sätt olämpligt i en upphandlingskontext</li>
              <li>Inte använda Tjänsten för att kringgå upphandlingsregler eller lagar</li>
              <li>Inte försöka få obehörig åtkomst till andra användares konton eller till våra system</li>
              <li>Inte använda Tjänsten på ett sätt som kan skada, avaktivera, överbelasta eller försämra den</li>
            </ul>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">6. Immateriella rättigheter</h2>
            <p>Tjänsten och dess innehåll ägs av Snabbaupphandlingar eller dess licensgivare och skyddas av upphovsrätt, varumärkesskydd och andra lagar om immateriella rättigheter.</p>
            <p>Du får inte kopiera, modifiera, distribuera, sälja eller hyra ut någon del av Tjänsten utan vårt uttryckliga tillstånd. Analysresultat du får genom tjänsten är dock för ditt eget bruk.</p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">7. Användarinnehåll</h2>
            <p>Du behåller alla rättigheter till innehåll som du laddar upp till Tjänsten (t.ex. företagsspecifik information), men du ger oss en global, icke-exklusiv, royaltyfri licens att använda, modifiera, anpassa, reproducera och distribuera sådant innehåll på Tjänsten för att tillhandahålla och förbättra våra upphandlingstjänster.</p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">8. Avgifter och betalning</h2>
            <p>Vissa funktioner av Tjänsten kräver betalning enligt våra prisplaner. Priser och betalningsvillkor för upphandlingsanalys anges på vår webbplats.</p>
            <p>Alla betalningar är icke-återbetalningsbara om inte annat uttryckligen anges eller om tjänsten haft väsentliga tekniska brister.</p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">9. Ansvarsbegränsning</h2>
            <p>Tjänsten tillhandahålls "i befintligt skick" och "som tillgänglig" utan några garantier av något slag, vare sig uttryckliga eller underförstådda.</p>
            <p>Vi garanterar inte att analyser och rekommendationer kommer att leda till framgång i upphandlingar. Slutligt ansvar för anbud och upphandlingsdeltagande ligger alltid hos användaren.</p>
            <p>I den utsträckning som tillämplig lag tillåter, ska Snabbaupphandlingar inte vara ansvarig för några direkta, indirekta, tillfälliga, särskilda, följd- eller exemplariska skador relaterade till användningen av tjänsten.</p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">10. Uppsägning</h2>
            <p>Vi kan avsluta eller stänga av din åtkomst till Tjänsten omedelbart, utan föregående meddelande eller ansvar, av vilket skäl som helst, inklusive utan begränsning om du bryter mot dessa villkor.</p>
            <p>Vid uppsägning upphör din rätt att använda Tjänsten omedelbart, men du kan begära export av dina upphandlingsdata inom 30 dagar.</p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">11. Ändringar av villkoren</h2>
            <p>Vi förbehåller oss rätten att ändra dessa villkor när som helst. Om vi gör det kommer vi att publicera de uppdaterade villkoren på denna sida och uppdatera datumet för "Senast uppdaterad" nedan.</p>
            <p>Din fortsatta användning av Tjänsten efter sådana ändringar utgör ditt godkännande av de nya villkoren.</p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">12. Tillämplig lag</h2>
            <p>Dessa villkor ska regleras och tolkas i enlighet med svensk lag, utan hänsyn till dess lagvalsregler.</p>
            <p>Eventuella tvister som uppstår ur eller i samband med dessa villkor ska slutligt avgöras av behörig domstol i Sverige.</p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">13. Kontakt</h2>
            <p>Om du har några frågor om dessa villkor eller om våra upphandlingstjänster, vänligen kontakta oss på:</p>
            <p className="mt-2">
              E-post: kontakt@snabbaupphandlingar.se<br />
              Adress: Skallebackavägen 13, 32 41 Halmstad
            </p>
          </section>
          
          <p className="mt-8 text-sm">Senast uppdaterad: 1 juni 2024</p>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Villkor;
